import Button, { type IButtonOptions } from 'devextreme-react/button';
import { useId } from 'react';

export interface ToolbarHintButtonProps extends IButtonOptions {
  hintTitle: string;
  hintLines: string[];
}

/**
 * Toolbar button with a compact, themed multi-line hover hint. Avoids DevExtreme's default
 * single-line tooltip strip for longer action explanations. Opens below the button so it
 * does not slide under the app header on top-aligned toolbars.
 */
export function ToolbarHintButton({ hintTitle, hintLines, ...buttonProps }: ToolbarHintButtonProps) {
  const tooltipId = useId().replace(/:/g, '');

  return (
    <span className="ops-toolbar-hint">
      <Button {...buttonProps} aria-describedby={tooltipId} />
      <span id={tooltipId} className="ops-toolbar-hint__popover" role="tooltip">
        <span className="ops-toolbar-hint__title">{hintTitle}</span>
        {hintLines.map((line) => (
          <span key={line} className="ops-toolbar-hint__line">
            {line}
          </span>
        ))}
      </span>
    </span>
  );
}
